import { useEffect, useState } from 'react';
import styled from './index.module.scss';
import { Tabs } from 'antd-v5';
import { WorkArrowIcon, WorkArrowIcon2, WorkIcon1, WorkIcon2, WorkIcon3, WorkIcon4, WorkIcon5 } from '@/components/UI/svg/Referral';
import { useReferralStore } from '@/components/ReferralHalloween/ReferralProvider';
import { useGlobal } from '@/utils/useGlobal';
import { getIsLogin } from '@/utils/cookie';

import type { TabsProps } from 'antd-v5';
import gtm from '@/utils/gtm';
import { signupCookie } from '@/utils/cookies/signupCookie';
import { useScheduledContent } from '@/utils/hooks/useScheduledContent';
import EcoImg from 'eco-design/base/eco-img';

const HowWorksNew = ({ onRefer }: any) => {
    const { useLang, useRouter } = useGlobal();
    const { inBlackList, actStatus } = useReferralStore();
    const [isLogin, setIsLogin] = useState(false);
    const router = useRouter();
    const { t } = useLang('referral');
    const stepCopyName = actStatus === 1 ? 'works.icondesc3_1' : 'works.icondesc3';

    const percentage = useScheduledContent({
        '2025/01/01 23:00:00 GMT+8': '4%',
        '2025/07/31 23:00:00 GMT+8': '6%',
        '2025/08/07 23:00:00 GMT+8': '5%',
    }) as string;

    const list = [
        {
            icon: <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760341611302/workicon1.png" />,
            desc: t('newworks.referrer.desc1'),
            btn: t('newworks.referrer.btn1'),
            title: t('newworks.referrer.title1'),
        },
        {
            icon: <WorkArrowIcon />,
        },
        {
            icon: <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760341645665/workicon2.png" />,
            desc: t('newworks.referrer.desc2'),
            btn: t('newworks.referrer.btn2'),
            title: t('newworks.referrer.title2'),
        },
        {
            icon: <WorkArrowIcon />,
        },
        {
            icon: <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760341659469/workicon3.png" />,
            title: t('newworks.referrer.title3'),
            desc: t.rich(stepCopyName, {
                bold: (text: string) => <span className="bold">{text}</span>,
            }),
        },
        {
            icon: <WorkArrowIcon />,
        },
        {
            icon: <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760341668024/workicon4.png" />,
            title: t('newworks.referrer.title4'),
            desc: t.rich('newworks.referrer.desc4', {
                bold: (text: string) => {
                    if (router?.locale === 'jp') text = percentage;
                    return <span className="bold">{text}</span>;
                },
            }),
        },
    ];

    const list2 = [
        {
            icon: <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760341611302/workicon1.png" />,
            desc: t('newworks.referee.desc1'),
            title: t('newworks.referee.title1'),
        },
        {
            icon: <WorkArrowIcon2 />,
        },
        {
            icon: <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760341668024/workicon4.png" />,
            title: t('newworks.referee.title2'),
            desc: t.rich('newworks.referee.desc2', {
                bold: (text: string) => <span className="bold">{text}</span>,
            }),
        },
        {
            icon: <WorkArrowIcon2 />,
        },
        {
            icon: <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1760343341663/workicon5%20(1).png" />,
            title: t('newworks.referee.title3'),
            desc: t.rich('newworks.referee.desc3', {
                bold: (text: string) => <span className="bold">{text}</span>,
            }),
        },
    ];

    const items: TabsProps['items'] = [
        {
            key: 'refer',
            label: t('newworks.tab1'),
            children: (
                <ul className="icon_box">
                    {list.map((item, index) => (
                        <li className={`item ${item.desc ? '' : 'arrow'}`} key={index}>
                            <div className="icon">{item.icon}</div>
                            <div className="text">
                                <p className="step">{item.title}</p>
                                <p className="desc">{item.desc}</p>
                                {item.btn && index === 0 && (
                                    <p
                                        className={`btn ${isLogin ? 'login' : ''}`}
                                        onClick={() => {
                                            signupCookie?.({
                                                sector_name: `${t('newworks.title')}_${item.title}`,
                                                entry_position: 2,
                                            });
                                            router.push(`/login?redirect=${encodeURIComponent(window.location.href)}`);
                                            try {
                                                gtm.push({
                                                    event: 'uaEvent',
                                                    event_name: 'referral_button',
                                                    position: t('newworks.title'),
                                                    button_name: item.btn,
                                                });
                                            } catch (e) {
                                                console.log(e);
                                            }
                                        }}
                                    >
                                        {item.btn}
                                    </p>
                                )}
                                {item.btn && index === 2 && !inBlackList && (
                                    <p
                                        className="btn refer"
                                        onClick={() => {
                                            onRefer && onRefer();
                                            try {
                                                gtm.push({
                                                    event: 'uaEvent',
                                                    event_name: 'referral_button',
                                                    position: t('newworks.title'),
                                                    button_name: item.btn,
                                                });
                                            } catch (e) {
                                                console.log(e);
                                            }
                                        }}
                                    >
                                        {item.btn}
                                    </p>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            ),
        },
        {
            key: 'referee',
            label: t('newworks.tab2'),
            children: (
                <ul className="icon_box">
                    {list2.map((item, index) => (
                        <li className={`item ${item.desc ? '' : 'arrow'}`} key={index}>
                            <div className="icon">{item.icon}</div>
                            <div className="text">
                                <p className="step">{item.title}</p>
                                <p className="desc">{item.desc}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            ),
        },
    ];

    useEffect(() => {
        setIsLogin(getIsLogin());
    }, []);

    return (
        <div className={`${styled.how_works}`}>
            <h3 className="title">{t('newworks.title')}</h3>
            <Tabs defaultActiveKey="refer" items={items} centered className="tabs_work" />
        </div>
    );
};

export default HowWorksNew;
